import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { OTPModel } from '../models/otp.model';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OTPService {
  apiUrl: string = environment.baseApi + 'sms/';

  constructor(private http: HttpClient) {}

  getOTP(mobileNumber: string) {
    const data = {
      mobileNumber: mobileNumber,
    };
    return this.http
      .post<OTPModel>(this.apiUrl + 'get-training-portal-otp/', data)
      .pipe(
        tap((resp) => {
          if (!environment.production) {
            console.log('OTP:', resp);
          }
        }),
      );
  }
}
